import {NavLink, useHistory} from "react-router-dom";
import {Home, Lock, LogOut, Package, User, Users} from "react-feather";
import {memo, useEffect, useState} from "react";
import {VscCompassActive} from "react-icons/vsc";
import {LiaStackExchange} from "react-icons/lia";
import {MdKeyboardDoubleArrowLeft} from "react-icons/md";
import {ACCESSORIES_ICON, INVERTER_ICON, PANEL_ICON, STORAGE_ICON} from "../../assets/images/Images";

const SideMenuBar = memo(({mobileShow}) => {
    const history = useHistory();
    const [userInfo, setUserInfo] = useState({
        Avatar: "", FirstName: "",
    });

    const loadUserInfo = async () => {
        await setUserInfo({FirstName: localStorage.getItem("UserName"), Avatar: localStorage.getItem("Avatar")})
    }
    useEffect(() => {
        if (!localStorage.getItem("UserId")) {
            history.push('/');
        } else {
            loadUserInfo();
        }
    }, []);

    return (<div className={`sidebar-menu-container ${mobileShow ? "show" : "hide"}`}>

        <div className='sidebar-menu' data-aos='fade-right'>
            {/*<button className='btn-back-dashboard' onClick={() => {*/}
            {/*    window.location.href = "https://dev.zeeshanhameed.net/";*/}
            {/*}}><MdKeyboardDoubleArrowLeft/> Back To Website*/}
            {/*</button>*/}
            <div className="sidebar-userblock" style={{marginTop: 20, marginBottom: 20,paddingBottom: 10}}>
                <img
                    src={userInfo.Avatar ? userInfo.Avatar : "https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png"}
                    alt="User Image"/>
                <h4 className="username">{userInfo.FirstName}</h4>
            </div>
            <div className="sidebar-menu-items">
                <ul>
                    <li>
                        <NavLink to={'/user/dashboard'} exact>
                            <Home/> Dashboard
                        </NavLink>
                    </li>
                    <li>

                        <NavLink to={'/user/profile'} exact>
                            <User/> My Profile</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/walls'} exact>
                            <img src={PANEL_ICON} alt="Panel Icon" style={{marginRight: '15px'}}/>
                            Walls
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/ceilings'} exact>
                            <img src={INVERTER_ICON} alt="Panel Icon" style={{marginRight: '15px'}}/>
                            Ceilings
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={'/user/change-password'} exact>
                            <Lock/> Change Password
                        </NavLink>
                    </li>
                    <li>
                        <a href='javascript:void(0)' onClick={() => {
                            document.cookie = "UserId=" + null;
                            document.cookie = "UserName=" + null;
                            document.cookie = "Email=" + null;
                            document.cookie = "Password=" + null;
                            localStorage.removeItem("UserId");
                            localStorage.removeItem("UserName");
                            localStorage.removeItem("Email");
                            localStorage.removeItem("Password");
                            history.push("/");
                        }}>
                            <LogOut/> Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>)
})
export default SideMenuBar;
